<div class="card">
    <div class="card-body">
        <div class="row mb-2">
            <div class="col-6">
                <h5 class="mt-0 mb-2">
                    Habilidades
                </h5>
            </div>
        </div>
    

        <div class="row mt-2 mb-2">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="card h-100">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-6">
                                <h5 class="mt-0 mb-2">
                                    Técnicas
                                </h5>
                            </div>
                            <div class="col-6">
                                <div class="text-end">
                                    <button type="button" (click)="addResumeSkill(false)" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#modalHabilidades">
                                        <i class="fa-regular fa-square-plus"></i>
                                        Nuevo
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-2">
                            <table class="table table-hover table-theme">
                                <thead>
                                    <tr>
                                        <th>Habilidad</th>
                                        <th>Nivel</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of skills(); let index = $index; track $index) {
                                        <tr>
                                            <td class="text-left">{{item.skillName}}</td>
                                            <td class="text-left">{{item.skillLevel}}</td>
                                            <td class="text-center">
                                                <button (click)="editResumeSkill(item, index, false)" type="button" class="btn btn-outline-success me-2"
                                                data-bs-toggle="modal" data-bs-target="#modalHabilidades">
                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                </button>
                                                <button (click)="deleteResumeSkill(item, index, false)" type="button" class="btn btn-outline-danger">
                                                    <i class="fa-regular fa-trash-can"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12 ">
                <div class="card h-100">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-6">
                                <h5 class="mt-0 mb-2">
                                    Blandas
                                </h5>
                            </div>
                            <div class="col-6">
                                <div class="text-end">
                                    <button type="button" (click)="addResumeSkill(true)" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#modalHabilidades">
                                        <i class="fa-regular fa-square-plus"></i>
                                        Nuevo
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-2">
                            <table class="table table-hover table-theme">
                                <thead>
                                    <tr>
                                        <th>Habilidad</th>
                                        <th>Nivel</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of softSkills(); let index = $index; track $index) {
                                        <tr>
                                            <td class="text-left">{{item.skillName}}</td>
                                            <td class="text-left">{{item.skillLevel}}</td>
                                            <td class="text-center">
                                                <button (click)="editResumeSkill(item, index, true)" type="button" class="btn btn-outline-success me-2"
                                                data-bs-toggle="modal" data-bs-target="#modalHabilidades">
                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                </button>
                                                <button (click)="deleteResumeSkill(item, index, true)" type="button" class="btn btn-outline-danger">
                                                    <i class="fa-regular fa-trash-can"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
         
        </div>

        <div class="row mt-2">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="card h-100">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-6">
                                <h5 class="mt-0 mb-2">
                                    Idiomas
                                </h5>
                            </div>
                            <div class="col-6">
                                <div class="text-end">
                                    <button type="button" (click)="addLanguage()" class="btn btn-outline-primary btn-sm" data-bs-toggle="modal" data-bs-target="#modalIdiomas">
                                        <i class="fa-regular fa-square-plus"></i>
                                        Nuevo
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-2">
                            <table class="table table-hover table-theme">
                                <thead>
                                    <tr>
                                        <th>Idioma</th>
                                        <th>Nivel</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (item of languages();  let index = $index; track $index) {
                                        <tr>
                                            <td class="text-left">{{item.languageName}}</td>
                                            <td class="text-left">{{item.languageLevel}}</td>
                                            <td class="text-center">
                                                <button (click)="editResumeLanguage(item, index)" type="button" class="btn btn-outline-success me-2"
                                                data-bs-toggle="modal" data-bs-target="#modalIdiomas">
                                                    <i class="fa-solid fa-pen-to-square"></i>
                                                </button>
                                                <button (click)="deleteResumeLanguage(item, index)" type="button" class="btn btn-outline-danger">
                                                    <i class="fa-regular fa-trash-can"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>


<app-modal-skill
[resumeId]="resumeId()"
(onResumeSkill)="handlerResumeSkill($event)"/>

<app-modal-language 
[resumeId]="resumeId()"
(onResumeLanguage)="handlerResumeLanguage($event)"/>